import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as accountsReducer from "containers/Accounts/reducer";
import * as viewReducer from "containers/View/reducer";

import AccountTile from "components/Tiles/AccountTile";
import EmptyWarning from "components/Tiles/EmptyWarning";
import SubView from "components/View/SubView";
import { isEnabled } from "utils/featureFlags";

class AccountViewContainer extends React.PureComponent {
  renderFirstTile() {
    const { handleCreateAWSAccount, handleCreateAzureAccount, handleCreateGCPAccount, isAzureAccount, hideFirstTile } =
      this.props;

    if (hideFirstTile) {
      return <div style={{ height: "170px" }}></div>;
    }

    return (
      <AccountTile
        isCreate
        onClick={() => handleTenantClick("new")}
        handleCreateAWSAccount={(name, id) => handleCreateAWSAccount(name, id)}
        handleCreateAzureAccount={isAzureAccount ? (name, config) => handleCreateAzureAccount(name, config) : () => {}}
        handleCreateGCPAccount={(name, config) => handleCreateGCPAccount(name, config)}
        isAzureAccount={isAzureAccount}
      />
    );
  }

  render() {
    const {
      isTile,
      noSelect,
      selectedAccountId,
      updateSelectedAccount,
      handleDelete,
      data,
      onClick,
      updateLookerURL,
      noHover,
      subViewType
    } = this.props;
    return (
      <SubView
        {...this.props}
        label="Accounts"
        firstTile={this.renderFirstTile()}
        // length={data.length}
        tileHeight={165}
        isInfinite
        childrenLength={(data && data.length) || 0}
        renderTile={(columnIndex, style) =>
          data && data.length > columnIndex ? (
            <div style={style} key={data[columnIndex].id}>
              <AccountTile
                key={data[columnIndex].id}
                id={data[columnIndex].id}
                account={data[columnIndex]}
                isSelected={!noSelect && selectedAccountId && selectedAccountId === data[columnIndex].id}
                onClick={() => (onClick ? onClick(data[columnIndex]) : updateSelectedAccount(data[columnIndex].id))}
                handleDelete={
                  isEnabled("chat-aible-consumer") && !isEnabled("chat-aible-advanced-controls")
                    ? undefined
                    : () => handleDelete(data[columnIndex].id)
                }
                noHover={noHover}
                updateLookerURL={updateLookerURL}
              />
            </div>
          ) : (
            ""
          )
        }
        isTile
        whenEmpty={
          <EmptyWarning
            title={"No cloud accounts found. Please link a cloud account to begin using Aible."}
            subTitle={
              <span>
                {
                  "You can link your cloud account using the New Account tile. If you require assistance, contact us at "
                }
                <a href="mailto:success@aible.com">success@aible.com</a>
              </span>
            }
          />
        }
        type={subViewType}
      >
        {/* {data &&
          data.map((account, i) => (
            <AccountTile
              id={account.id}
              account={account}
              key={i}
              isSelected={selectedAccountId && selectedAccountId === account.id}
              onClick={() => updateSelectedAccount(account.id)}
              handleDelete={() => handleDelete(account.id)}
            />
          ))} */}
      </SubView>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSelectedAccount: (accountId) => dispatch(accountsReducer.handleSelect(accountId)),
  handleCreateAWSAccount: (name, awsAccountID) => dispatch(accountsReducer.handleCreateAWSAccount(name, awsAccountID)),
  handleCreateAzureAccount: (name, config) => dispatch(accountsReducer.handleCreateAzureAccount(name, config)),
  handleCreateGCPAccount: (name, config) => dispatch(accountsReducer.handleCreateGCPAccount(name, config)),
  handleDelete: (accountId) => dispatch(accountsReducer.handleDelete(accountId)),
  updateLookerURL: (data) => dispatch(accountsReducer.updateLookerURL(data))
});

const mapStateToProps = (state, ownProps) => ({
  type: viewReducer.getSettingsType(state),

  data: viewReducer.getAccounts(state),
  isLoading: accountsReducer.getIsLoading(state),

  selectedAccountId: accountsReducer.getSelectedAccountId(state),

  isAzureAccount: accountsReducer.getIsAzureAccount()
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(AccountViewContainer);
